const Config = {
  baseUrl: window.location.protocol + '//' + window.location.host
}

export default Config;


// WEBPACK FOOTER //
// ./src/config/config.js